export default __webpack_public_path__ + "locales/fi/Settings.json?hash=8b1e01bbe8bf3a71c3430e85692962f5";